export interface ISurgeryKitDetail {
    surgeryKitDetailId: number;
    surgeryKitHeaderId: number;
    quantity: number;
    pharmacyProductId: number;
    productName: string;
    genericName: string;
}